import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import AAimage from '../images/AA Smartfuel Logo.jpg';
import stuffLogo from '../images/stufflogo.png';
import weatherZoneLogo from '../images/weatherzone3.png';
import sevenLogo from '../images/swmlogo2.png';
import NZMELogo from '../images/NZME.jpeg'
import Header from './Header';
import AutosuggestComponent from '../components/public/AutosuggestComponent';
import { isEmptyArray, arrayUnique, sortArrayAlphabetically,searchStringInObjectArray } from '../utilities/helpers';

import {
  setAudienceType,
  setIndustryAction,
  setOrganisationAction,
  setHomeAction,
} from '../store/actions/audienceBuilder-actions';

const AudienceBuilderSelectType = () => {
  const dispatch = useDispatch();
  const clientId = useSelector(state => state.client.id);
  const organisationList = useSelector(state => {
    let footfallArray;
    let mobileDeviceArray;
    // combine 2 organisation list
    state.reports.reports.forEach(item => {
      if (item.name === 'footfall') {
        footfallArray = item.organisation;
      } else if (item.name === 'mobileDevices') {
        mobileDeviceArray = item.organisation;
      }
    });
    console.log(mobileDeviceArray)
    // Filter duplicate organisation and sort alphabetically

    if (!isEmptyArray(mobileDeviceArray)) {
      const uniqueArray = arrayUnique(footfallArray.concat(mobileDeviceArray));
      const sortedArray = sortArrayAlphabetically(uniqueArray);
      return sortedArray
    }
      return footfallArray;

  });

  const industryList = useSelector(
    state => {
      let footfallArray;
      let mobileDeviceArray;
      // check the correct options
      state.reports.reports.forEach(item => {
        if (item.name === 'footfall') {
          footfallArray = item.audienceBuilderIndustryOptions.concat();
        } else if (item.name === 'mobileDevices') {
          mobileDeviceArray = item.audienceBuilderIndustryOptions.concat();
        }
      });

      if(mobileDeviceArray){
        mobileDeviceArray.map(item =>{
          const searchResult = searchStringInObjectArray(item.label, footfallArray, 'name')

         if(searchResult){ // if category is there. insert into array
          footfallArray[searchResult.idx].options.concat(item.options)
         }else{ // if not,create one.
          footfallArray.push(item)
         }
      })
      }


     return footfallArray
    }
  );

  const [selectedType, setSelectedType] = useState(null);
  const [industry, setIndustry] = useState(null);
  const [organisation, setOrganisation] = useState(null);
  const [home, setHome] = useState(null);

  const handleTypeChange = e => {
    const stringSplitLocation = e.label.indexOf('-');

    const newObject = {
      label: e.label.slice(0, stringSplitLocation),
      value: e.value,
    };
    setSelectedType(newObject);
    setIndustry(null);
    setOrganisation(null);
    setHome(null);
    dispatch(setAudienceType(e.value));
    dispatch(setHomeAction(null));
  };

  const handleIndustryChange = e => {
    isEmptyArray(e) ? setIndustry(null) : setIndustry(e);
    dispatch(setIndustryAction(e));
  };

  const handleOrganisationChange = e => {
    isEmptyArray(e) ? setOrganisation(null) : setOrganisation(e);
    dispatch(setOrganisationAction(e));
  };

  const handleHomeChange = e => {
    setHome(e);
    dispatch(setHomeAction(e));
  };

  return (
    <div>
      <Header />

      <main>
        <div className="Account_top" style={{ padding: '1rem 2rem' }}>
          <div className="container" style={{ margin: 0 }}>
            <h1>Audience Builder</h1>
          </div>
        </div>

        {clientId === '5bda6310b70f775e362ef3df' && (
          <div
            className="Audience_logo-area"
            style={{ paddingTop: '7rem', paddingBottom: '8rem' }}
          >
            <img src={AAimage} alt="AAimage" />
          </div>
        )}

        {clientId === '5dc23419f085fa1230a4f923' && (
          <div
            className="Audience_logo-area"
            style={{ paddingTop: '7rem', paddingBottom: '8rem' }}
          >
            <img src={stuffLogo} alt="stuffLogo" />
          </div>
        )}

        {clientId === '5d3fa7dfe5f4090d59ea1511' && (
          <div className="Audience_logo-area"
          style={{ paddingTop: '7rem', paddingBottom: '8rem' }}
          >
            <img src={weatherZoneLogo} alt="weatherZoneLogo" />
          </div>
        )}
        {clientId === '5f217c8b092bbc0c58e32f99' && (
          <div className="Audience_logo-area"
          style={{ paddingTop: '5rem', paddingBottom: '0rem' }}
          >
            <img src={sevenLogo} alt="sevenLogo" />
          </div>
        )}
        {clientId === '60cad86b164bbf00021e42aa' && (
          <div className="Audience_logo-area"
          style={{ paddingTop: '5rem', paddingBottom: '0rem' }}
          >
            <img src={NZMELogo} alt="NZMELogo" />
          </div>
        )}

        <div
          className={`Audience_select-type-area${
            clientId === '5bda6310b70f775e362ef3df' ||
            clientId === '5dc23419f085fa1230a4f923' ||
            clientId === '5d3fa7dfe5f4090d59ea1511'
              ? `_withImg`
              : ''
          }`}
        >
          <h3 style={{ fontSize: '1rem' }}> Audience type</h3>
          <Select
            inputId="criteria-modal-select-organisation"
            className="CriteriaModal_search-organisation-input"
            classNamePrefix="CriteriaModal_search-organisation-input_"
            placeholder="Type to search"
            isDisabled={false}
            isRtl={false}
            isSearchable
            name="audience-type"
            options={[
              {
                label:
                  'Industry - Build an audience of customers who have an association to one or more Industry Categories',
                value: 'subcategory',
              },
              {
                label:
                  'Brand - Build an audience of customers who have an association to one or more Brands',
                value: 'organization',
              },
              {
                label:
                  'Home - Build an audience of customers based on one or more Home locations',
                value: 'home',
              },
            ]}
            value={selectedType}
            onChange={event => handleTypeChange(event)}
          />

          {selectedType !== null && selectedType.value === 'subcategory' && (
            <React.Fragment>
              <h3 style={{ fontSize: '1rem', paddingTop: '2rem' }}>
                Select Industry
              </h3>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isDisabled={false}
                isClearable
                isMulti
                isRtl={false}
                isSearchable
                name="audience-type"
                options={industryList}
                value={industry}
                onChange={event => handleIndustryChange(event)}
              />
            </React.Fragment>
          )}

          {selectedType !== null && selectedType.value === 'organization' && (
            <React.Fragment>
              <h3 style={{ fontSize: '1rem', paddingTop: '2rem' }}>
                Select Brand
              </h3>
              <Select
                inputId="criteria-modal-select-organisation"
                className="CriteriaModal_search-organisation-input"
                classNamePrefix="CriteriaModal_search-organisation-input_"
                placeholder="Type to search"
                isDisabled={false}
                isClearable
                isRtl={false}
                isMulti
                isSearchable
                name="audience-type"
                options={organisationList}
                value={organisation}
                onChange={event => handleOrganisationChange(event)}
              />
            </React.Fragment>
          )}

          {selectedType !== null && selectedType.value === 'home' && (
            <React.Fragment>
              <h3 style={{ fontSize: '1rem', paddingTop: '2rem' }}>
                Select home locations
              </h3>
              <AutosuggestComponent handleHomeChange={handleHomeChange} />
            </React.Fragment>
          )}

          {selectedType !== null &&
            (organisation !== null || industry !== null || home !== null) && (
              <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                <Link
                  to="/audience-builder"
                  className="Header_create-location-insights-button"
                >
                  <span> Build Audience</span>
                </Link>
              </div>
            )}
        </div>
      </main>
    </div>
  );
};

export default AudienceBuilderSelectType;
